/**
 * Partner hub request status
 */
export enum HubRequestStatus {
  PENDING = 'pending',
  UNDER_REVIEW = 'under_review',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

/**
 * Partner hub request interface
 */
export interface HubRequest {
  id: string;
  companyName: string;
  contactName: string;
  email: string;
  phoneNumber: string;
  address: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    coordinates?: {
      latitude: number;
      longitude: number;
    };
  };
  siteImages: string[]; // Storage URLs
  businessType: string; // e.g., "hotel", "restaurant", "retail"
  estimatedFootTraffic?: string;
  parkingAvailable: boolean;
  indoorStorage: boolean;
  notes?: string;
  status: HubRequestStatus;
  submittedAt: Date;
  reviewedAt?: Date;
  reviewedBy?: string; // Admin user ID
  rejectionReason?: string;
}

